"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const legalServices = [{
  id: "item-1",
  title: "Ceza Hukuku",
  description: "Türk Ceza Kanunu ve Ceza Muhakemesi Kanunu kapsamında, soruşturma ve kovuşturma evrelerinde şüpheli, sanık veya müşteki vekilliği hizmetleri. Ağır Ceza, Asliye Ceza ve Sulh Ceza Hakimlikleri nezdinde yürütülen davaların takibi, tutukluluğa itiraz, istinaf ve temyiz süreçlerinin yönetimi."
}, {
  id: "item-2",
  title: "Aile ve Boşanma Hukuku",
  description: "Türk Medeni Kanunu çerçevesinde çekişmeli ve anlaşmalı boşanma davaları, mal rejiminin tasfiyesi, velayet ve nafaka uyuşmazlıkları, soybağı kurulması ve reddi davaları ile aile konutu şerhi işlemlerinin hukuki zeminde yürütülmesi."
}, {
  id: "item-3",
  title: "Kurumsal Hukuki Danışmanlık ve Şirketler Hukuku",
  description: "Ticaret şirketlerinin kuruluş, genel kurul, sermaye artırımı/azaltımı süreçleri, birleşme ve devralma işlemleri, ticari sözleşmelerin hazırlanması ve revizesi, haksız rekabet davaları ve kurumsal yönetim ilkelerine uyum danışmanlığı."
}, {
  id: "item-4",
  title: "Gayrimenkul ve İnşaat Hukuku",
  description: "Arsa payı karşılığı inşaat sözleşmelerinin hazırlanması ve feshi, tapu iptal ve tescil davaları, kamulaştırma ve kamulaştırmasız el atma davaları, kira tespit ve tahliye davaları ile gayrimenkul satış vaadi sözleşmelerinden doğan uyuşmazlıkların çözümü."
}, {
  id: "item-5",
  title: "İş Hukuku ve Uzman Arabuluculuk",
  description: "İşçi ve işveren arasındaki hizmet sözleşmelerinin düzenlenmesi, işe iade, kıdem ve ihbar tazminatı davaları, iş kazası ve meslek hastalığı kaynaklı tazminat süreçleri. İş hukukunda uzman arabuluculuk kapsamında uyuşmazlıkların dava dışı yöntemlerle çözümlenmesi."
}, {
  id: "item-6",
  title: "Sigorta ve Trafik Kazası Tazminatları",
  description: "Ölümlü ve yaralamalı trafik kazalarından doğan maddi ve manevi tazminat talepleri, destekten yoksun kalma tazminatı, maluliyet tazminatı hesaplamaları ve Sigorta Tahkim Komisyonu nezdindeki başvuruların takibi."
}, {
  id: "item-7",
  title: "İdari Yargı, İcra Hukuku ve Bireysel Başvurular",
  description: "İdari işlemlerin iptali ve tam yargı davaları, ilamlı ve ilamsız icra takipleri, borca itiraz ve menfi tespit davaları. İç hukuk yollarının tüketilmesi akabinde Anayasa Mahkemesi ve Avrupa İnsan Hakları Mahkemesi'ne bireysel başvuru süreçleri."
}];
export default function LegalBranches() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hukuki-branşlar" className="dark bg-linear-to-b from-[#0f172a] to-[#121212] text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />

      <div ref={ref} className={cn("max-w-5xl mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="mb-16 border-l-2 border-primary pl-6">
          <h2 className="text-3xl md:text-4xl font-serif font-medium tracking-tight text-slate-300 mb-4">
            Uzmanlık Alanları
          </h2>
          <p className="text-muted-foreground font-sans text-lg max-w-2xl leading-relaxed">
            Hukuki süreçlerin teknik detaylarına hakim, mevzuata uygun ve çözüm
            odaklı yaklaşımımızla sunduğumuz hizmetlerin kapsamı.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {legalServices.map((service, index) => <AccordionItem key={service.id} value={service.id} className="border-b border-white/10 last:border-0" data-index={index}>
              <AccordionTrigger className="text-xl md:text-2xl font-serif font-normal py-6 md:py-8 hover:text-primary transition-colors text-left hover:no-underline [&[data-state=open]]:text-primary">
                <span className="flex items-center gap-4">
                  <span className="text-xs font-sans text-amber-700/80 uppercase tracking-widest w-8">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>
                  {service.title}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-muted-foreground leading-relaxed pb-8 pl-12 max-w-4xl">
                {service.description}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}